
import { Component, Vue } from 'vue-property-decorator';
// import Navigation from '@/components/navigation/Navigation.vue'; // @ is an alias to /src

@Component({})
export default class App extends Vue {

  private defaultLayout = 'default';
  get layout() {
    if (this.$route && this.$route.meta && this.$route.meta.layout) {
      return this.$route.meta.layout + '-layout';
    } else {
      return this.defaultLayout + '-layout';
    }
  }
}
